import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'redux/rootReducer'
/**
 * Direct selector to the user state domain
 */

const selectUtilisateurDomain = (state: AppState) => state.utilisateur

/**
 * Other specific selectors
 */

export const makeSelectUtilisateur = createSelector(
  selectUtilisateurDomain,
  (substate) => substate.utilisateur
)

export const makeSelectErrorMsg = createSelector(
  selectUtilisateurDomain,
  (substate) => substate.errorMsg
)

export const makeSelectStatus = createSelector(
  selectUtilisateurDomain,
  (substate) => substate.status
)

/**
 * Default selector
 */

const selectUtilisateur = createSelector(
  selectUtilisateurDomain,
  (substate) => substate
)

export default selectUtilisateur
